/* TEYRA STUDIO — Luxe gallery
   Upgrades every .project-gallery-viewer into a cinematic viewer + immersive lightbox.
   Works with both render paths (Liquid section and the JS-rendered case study).
   Features: ambient colour glow from the photo, FLIP open animation, crossfade,
   zoom (wheel / double-click / pinch), drag-to-pan, swipe, swipe-down to close,
   keyboard, slideshow with progress, auto-hiding chrome, focus trap. */
(() => {
  const T = (k, d, v) => (window.teyraT ? window.teyraT(k, d, v) : d);
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const EASE = 'cubic-bezier(.16,1,.3,1)';
  const pad = n => String(n).padStart(2, '0');
  const ICON = {
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
    expand: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    play: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg>',
    pause: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5h3v14H8zM13 5h3v14h-3z" fill="currentColor"/></svg>',
    zoom: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M16 16l4.5 4.5M11 8.5v5M8.5 11h5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
  };
  const btn = (cls, label, icon) => `<button type="button" class="${cls}" aria-label="${label}" title="${label}">${icon}</button>`;
  const altText = (title, n, total) => title ? T('gal_alt', '{title} — website design preview {n} of {total}', {title, n, total}) : '';
  const preload = src => { const i = new Image(); i.decoding = 'async'; i.src = src; };

  /* ------------------------------------------------------------ Lightbox */
  let lb = null;

  function openLightbox(images, startIndex, title, originEl) {
    if (lb) return;
    const opener = document.activeElement;
    let index = startIndex;
    let playing = false;
    let idleTimer = 0;
    let zoom = {s: 1, x: 0, y: 0};
    let slide = null; // {el, img}
    const MAX = 4;

    const root = document.createElement('div');
    root.className = 'lx';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', title || T('gal_title', 'Photo gallery'));
    root.innerHTML = `
      <div class="lx-ambient" aria-hidden="true"><img alt=""></div>
      <div class="lx-vignette" aria-hidden="true"></div>
      <div class="lx-grain" aria-hidden="true"></div>
      <div class="lx-progress" aria-hidden="true"><i></i></div>
      <header class="lx-top lx-chrome">
        <div class="lx-meta"><span class="lx-title">${title ? title.replace(/[<>&]/g, '') : ''}</span><span class="lx-count" aria-live="polite"></span></div>
        <div class="lx-tools">
          ${images.length > 1 ? btn('lx-btn lx-play', T('gal_play', 'Start slideshow'), ICON.play) : ''}
          ${btn('lx-btn lx-zoom', T('gal_zoom', 'Zoom'), ICON.zoom)}
          ${btn('lx-btn lx-close', T('gal_close', 'Close'), ICON.close)}
        </div>
      </header>
      <div class="lx-stage"></div>
      ${images.length > 1 ? btn('lx-nav lx-prev lx-chrome', T('gal_prev', 'Previous photo'), ICON.prev) + btn('lx-nav lx-next lx-chrome', T('gal_next', 'Next photo'), ICON.next) : ''}
      ${images.length > 1 ? `<footer class="lx-foot lx-chrome"><div class="lx-strip">${images.map((s, i) => `<button type="button" class="lx-thumb" data-i="${i}" aria-label="${T('gal_show', 'Show photo {n}', {n: i + 1})}"><img src="${s}" alt="" loading="lazy" decoding="async"></button>`).join('')}</div></footer>` : ''}`;
    document.body.appendChild(root);
    document.documentElement.classList.add('lx-open');

    const $ = s => root.querySelector(s);
    const stage = $('.lx-stage');
    const ambientImg = $('.lx-ambient img');
    const countEl = $('.lx-count');
    const progress = $('.lx-progress i');
    const thumbs = Array.from(root.querySelectorAll('.lx-thumb'));
    const playBtn = $('.lx-play');

    const apply = (animate) => {
      if (!slide) return;
      slide.pan.style.transition = animate ? `transform .45s ${EASE}` : 'none';
      slide.pan.style.transform = `translate3d(${zoom.x}px,${zoom.y}px,0) scale(${zoom.s})`;
      root.classList.toggle('is-zoomed', zoom.s > 1.01);
    };
    const clamp = () => {
      if (!slide) return;
      const r = slide.img.getBoundingClientRect();
      const w = r.width / zoom.s, h = r.height / zoom.s;
      const mx = Math.max(0, (w * zoom.s - stage.clientWidth) / 2);
      const my = Math.max(0, (h * zoom.s - stage.clientHeight) / 2);
      zoom.x = Math.min(mx, Math.max(-mx, zoom.x));
      zoom.y = Math.min(my, Math.max(-my, zoom.y));
    };
    const zoomAt = (s2, cx, cy, animate) => {
      s2 = Math.min(MAX, Math.max(1, s2));
      const box = stage.getBoundingClientRect();
      const px = cx - (box.left + box.width / 2), py = cy - (box.top + box.height / 2);
      const k = s2 / zoom.s;
      zoom.x = px - (px - zoom.x) * k;
      zoom.y = py - (py - zoom.y) * k;
      zoom.s = s2;
      if (s2 <= 1.001) { zoom = {s: 1, x: 0, y: 0}; }
      clamp();
      apply(animate);
    };
    const resetZoom = () => { zoom = {s: 1, x: 0, y: 0}; apply(false); };

    const setMeta = () => {
      countEl.textContent = `${pad(index + 1)} / ${pad(images.length)}`;
      ambientImg.src = images[index];
      thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      const t = thumbs[index];
      if (t && t.parentElement) t.parentElement.scrollTo({left: t.offsetLeft - t.parentElement.clientWidth / 2 + t.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth'});
      preload(images[(index + 1) % images.length]);
      preload(images[(index - 1 + images.length) % images.length]);
    };

    const makeSlide = src => {
      const el = document.createElement('div');
      el.className = 'lx-slide';
      const pan = document.createElement('div');
      pan.className = 'lx-pan';
      const img = document.createElement('img');
      img.className = 'lx-img';
      img.alt = altText(title, index + 1, images.length);
      img.draggable = false;
      img.decoding = 'async';
      img.src = src;
      pan.appendChild(img);
      el.appendChild(pan);
      return {el, pan, img};
    };

    const restartProgress = () => {
      progress.style.animation = 'none';
      void progress.offsetWidth;
      if (playing) progress.style.animation = 'lx-progress 5.5s linear forwards';
    };

    const go = (to, dir, first) => {
      const n = images.length;
      to = ((to % n) + n) % n;
      if (!first && to === index) return;
      dir = dir || (to > index ? 1 : -1);
      index = to;
      const old = slide;
      zoom = {s: 1, x: 0, y: 0};
      slide = makeSlide(images[index]);
      stage.appendChild(slide.el);
      setMeta();
      restartProgress();
      if (first) {
        // FLIP from the inline viewer image
        const show = () => {
          if (reduce || !originEl) return;
          const from = originEl.getBoundingClientRect();
          const to2 = slide.img.getBoundingClientRect();
          if (!from.width || !to2.width) return;
          const sx = from.width / to2.width;
          const dx = from.left + from.width / 2 - (to2.left + to2.width / 2);
          const dy = from.top + from.height / 2 - (to2.top + to2.height / 2);
          slide.img.animate([
            {transform: `translate(${dx}px,${dy}px) scale(${sx})`, borderRadius: '18px'},
            {transform: 'none', borderRadius: '2px'}
          ], {duration: 720, easing: EASE});
        };
        if (slide.img.complete) show(); else { slide.img.addEventListener('load', show, {once: true}); }
        if (!reduce) {
          root.animate([{opacity: 0}, {opacity: 1}], {duration: 420, easing: 'ease-out'});
          root.querySelectorAll('.lx-chrome').forEach((c, i) => c.animate([{opacity: 0, transform: 'translateY(8px)'}, {opacity: 1, transform: 'none'}], {duration: 700, delay: 260 + i * 70, easing: EASE, fill: 'backwards'}));
        }
        return;
      }
      if (reduce) { if (old) old.el.remove(); return; }
      const dist = Math.min(80, stage.clientWidth * 0.08) * dir;
      slide.img.style.opacity = '0';
      slide.el.animate([
        {opacity: 0, transform: `translateX(${dist}px) scale(1.04)`, filter: 'blur(14px)'},
        {opacity: 1, transform: 'none', filter: 'blur(0)'}
      ], {duration: 900, easing: EASE, fill: 'both'}).finished.then(() => { slide && (slide.el.style.filter = ''); }).catch(() => {});
      slide.img.style.opacity = '';
      if (old) {
        old.el.style.pointerEvents = 'none';
        old.el.animate([
          {opacity: 1, transform: 'none', filter: 'blur(0)'},
          {opacity: 0, transform: `translateX(${-dist * 0.6}px) scale(.97)`, filter: 'blur(10px)'}
        ], {duration: 600, easing: EASE, fill: 'forwards'}).finished.then(() => old.el.remove()).catch(() => old.el.remove());
      }
    };

    const next = () => go(index + 1, 1);
    const prev = () => go(index - 1, -1);

    const setPlaying = on => {
      playing = on && images.length > 1;
      root.classList.toggle('is-playing', playing);
      if (playBtn) {
        playBtn.innerHTML = playing ? ICON.pause : ICON.play;
        const l = playing ? T('gal_pause', 'Pause slideshow') : T('gal_play', 'Start slideshow');
        playBtn.setAttribute('aria-label', l); playBtn.title = l;
      }
      restartProgress();
    };
    progress.addEventListener('animationend', () => { if (playing) next(); });

    const close = () => {
      if (!lb) return;
      lb = null;
      clearTimeout(idleTimer);
      document.removeEventListener('keydown', onKey, true);
      window.removeEventListener('resize', onResize);
      const done = () => {
        root.remove();
        document.documentElement.classList.remove('lx-open');
        if (opener && opener.focus) opener.focus({preventScroll: true});
      };
      if (reduce) return done();
      // fly back to the inline image if it is still visible
      if (originEl && slide) {
        const from = slide.img.getBoundingClientRect();
        const to = originEl.getBoundingClientRect();
        if (to.width && to.bottom > 0 && to.top < innerHeight) {
          slide.img.animate([
            {transform: 'none'},
            {transform: `translate(${to.left + to.width / 2 - (from.left + from.width / 2)}px,${to.top + to.height / 2 - (from.top + from.height / 2)}px) scale(${to.width / from.width})`}
          ], {duration: 520, easing: EASE, fill: 'forwards'});
        }
      }
      root.querySelectorAll('.lx-chrome').forEach(c => c.animate([{opacity: 1}, {opacity: 0}], {duration: 200, fill: 'forwards'}));
      root.animate([{opacity: 1}, {opacity: 0}], {duration: 480, delay: 120, easing: 'ease-in', fill: 'forwards'}).finished.then(done).catch(done);
    };

    /* idle chrome — keeps the photo the hero */
    const wake = () => {
      root.classList.remove('is-idle');
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => root.classList.add('is-idle'), 3200);
    };
    ['pointermove', 'pointerdown', 'keydown', 'touchstart'].forEach(ev => root.addEventListener(ev, wake, {passive: true}));
    wake();

    /* controls */
    root.addEventListener('click', e => {
      const t = e.target.closest('button');
      if (!t) return;
      if (t.classList.contains('lx-close')) close();
      else if (t.classList.contains('lx-next')) next();
      else if (t.classList.contains('lx-prev')) prev();
      else if (t.classList.contains('lx-play')) setPlaying(!playing);
      else if (t.classList.contains('lx-zoom')) {
        const b = stage.getBoundingClientRect();
        zoomAt(zoom.s > 1.01 ? 1 : 2.4, b.left + b.width / 2, b.top + b.height / 2, true);
      } else if (t.classList.contains('lx-thumb')) { const i = Number(t.dataset.i); go(i, i > index ? 1 : -1); }
    });

    function onKey(e) {
      if (!lb) return;
      const k = e.key;
      if (k === 'Escape') { e.preventDefault(); e.stopPropagation(); zoom.s > 1.01 ? (zoomAt(1, innerWidth / 2, innerHeight / 2, true)) : close(); }
      else if (k === 'ArrowRight') { e.preventDefault(); zoom.s > 1.01 ? (zoom.x -= 80, clamp(), apply(true)) : next(); }
      else if (k === 'ArrowLeft') { e.preventDefault(); zoom.s > 1.01 ? (zoom.x += 80, clamp(), apply(true)) : prev(); }
      else if (k === ' ' && document.activeElement === document.body || (k === ' ' && !document.activeElement.closest('button'))) { e.preventDefault(); setPlaying(!playing); }
      else if (k === '+' || k === '=') { e.preventDefault(); zoomAt(zoom.s * 1.5, innerWidth / 2, innerHeight / 2, true); }
      else if (k === '-' || k === '_') { e.preventDefault(); zoomAt(zoom.s / 1.5, innerWidth / 2, innerHeight / 2, true); }
      else if (k === 'Tab') { // focus trap
        const f = Array.from(root.querySelectorAll('button')).filter(b => b.offsetParent !== null);
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || !root.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    document.addEventListener('keydown', onKey, true);
    const onResize = () => { clamp(); apply(false); };
    window.addEventListener('resize', onResize);

    /* wheel zoom */
    stage.addEventListener('wheel', e => {
      e.preventDefault();
      zoomAt(zoom.s * Math.exp(-e.deltaY * (e.ctrlKey ? 0.01 : 0.0018)), e.clientX, e.clientY, false);
    }, {passive: false});
    stage.addEventListener('dblclick', e => {
      if (!e.target.closest('.lx-img')) return;
      zoomAt(zoom.s > 1.01 ? 1 : 2.6, e.clientX, e.clientY, true);
    });

    /* pointer gestures: pan, pinch, swipe, swipe-down-to-close */
    const ptrs = new Map();
    let g = null, lastTap = {t: 0, x: 0, y: 0};
    stage.addEventListener('pointerdown', e => {
      if (e.button > 0) return;
      stage.setPointerCapture(e.pointerId);
      ptrs.set(e.pointerId, {x: e.clientX, y: e.clientY});
      if (ptrs.size === 1) g = {sx: e.clientX, sy: e.clientY, zx: zoom.x, zy: zoom.y, moved: 0, t: performance.now(), onImg: !!e.target.closest('.lx-img')};
      if (ptrs.size === 2) {
        const [a, b] = Array.from(ptrs.values());
        g = {pinch: true, d: Math.hypot(a.x - b.x, a.y - b.y), s: zoom.s, moved: 99};
      }
    });
    stage.addEventListener('pointermove', e => {
      if (!ptrs.has(e.pointerId) || !g) return;
      ptrs.set(e.pointerId, {x: e.clientX, y: e.clientY});
      if (g.pinch && ptrs.size >= 2) {
        const [a, b] = Array.from(ptrs.values());
        const d = Math.hypot(a.x - b.x, a.y - b.y);
        zoomAt(g.s * d / g.d, (a.x + b.x) / 2, (a.y + b.y) / 2, false);
        return;
      }
      const dx = e.clientX - g.sx, dy = e.clientY - g.sy;
      g.moved = Math.max(g.moved, Math.hypot(dx, dy));
      if (zoom.s > 1.01) {
        zoom.x = g.zx + dx; zoom.y = g.zy + dy; clamp(); apply(false);
        stage.classList.add('is-grabbing');
      } else if (slide && g.moved > 6) {
        // follow finger a little: horizontal swipe / vertical dismiss
        const v = Math.abs(dy) > Math.abs(dx);
        slide.pan.style.transition = 'none';
        slide.pan.style.transform = v ? `translate3d(0,${dy}px,0) scale(${1 - Math.min(.12, Math.abs(dy) / 1400)})` : `translate3d(${dx * .55}px,0,0)`;
        if (v) root.style.setProperty('--lx-dim', String(Math.max(0, 1 - Math.abs(dy) / 380)));
      }
    });
    const end = e => {
      if (!ptrs.has(e.pointerId)) return;
      ptrs.delete(e.pointerId);
      stage.classList.remove('is-grabbing');
      if (!g) return;
      if (g.pinch) { if (ptrs.size < 2) { g = null; } return; }
      const dx = e.clientX - g.sx, dy = e.clientY - g.sy;
      const wasTap = g.moved < 8 && performance.now() - g.t < 350;
      const onImg = g.onImg;
      const zoomed = zoom.s > 1.01;
      g = null;
      root.style.removeProperty('--lx-dim');
      if (!zoomed) {
        if (Math.abs(dx) > 70 && Math.abs(dx) > Math.abs(dy) * 1.4) { apply(true); dx < 0 ? next() : prev(); return; }
        if (dy > 110 && Math.abs(dy) > Math.abs(dx) * 1.4) { close(); return; }
        apply(true);
      }
      if (wasTap) {
        if (e.pointerType === 'touch' && onImg) {
          const now = performance.now();
          if (now - lastTap.t < 320 && Math.hypot(e.clientX - lastTap.x, e.clientY - lastTap.y) < 30) {
            zoomAt(zoom.s > 1.01 ? 1 : 2.6, e.clientX, e.clientY, true); lastTap.t = 0; return;
          }
          lastTap = {t: now, x: e.clientX, y: e.clientY};
          root.classList.toggle('is-idle');
        } else if (!onImg && !zoomed) { close(); }
      }
    };
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);

    lb = {close};
    go(index, 0, true);
    setMeta();
    (root.querySelector('.lx-close') || root).focus({preventScroll: true});
  }

  /* ------------------------------------------------------------ Inline viewer */
  function enhance(viewer) {
    if (viewer.dataset.lux) return;
    const thumbEls = Array.from(viewer.querySelectorAll('.project-gallery-thumb'));
    const mainEl = viewer.querySelector('.project-gallery-main-image');
    let images = thumbEls.map(t => t.dataset.gallerySrc || (t.querySelector('img') || {}).src).filter(Boolean);
    if (!images.length && mainEl && mainEl.src) images = [mainEl.src];
    if (!images.length) return;
    images = Array.from(new Set(images));
    viewer.dataset.lux = '1';
    const h1 = document.querySelector('h1');
    const title = h1 ? h1.textContent.trim() : '';
    const many = images.length > 1;
    let index = 0;

    viewer.classList.add('lux-gallery');
    viewer.innerHTML = `
      <div class="lg-stage" tabindex="0" role="button" aria-label="${T('gal_open', 'Open photo {n} full screen', {n: 1})}">
        <div class="lg-ambient" aria-hidden="true"><img alt=""></div>
        <div class="lg-frame"><img class="lg-img" alt="${altText(title, 1, images.length).replace(/"/g, '&quot;')}" fetchpriority="high" decoding="async"></div>
        <span class="lg-count" aria-hidden="true"><b>01</b><i></i>${pad(images.length)}</span>
        <span class="lg-hint" aria-hidden="true">${ICON.expand}<em>${T('gal_hint', 'View full screen')}</em></span>
        ${many ? btn('lg-nav lg-prev', T('gal_prev', 'Previous photo'), ICON.prev) + btn('lg-nav lg-next', T('gal_next', 'Next photo'), ICON.next) : ''}
        ${many ? '<div class="lg-bar" aria-hidden="true"><i></i></div>' : ''}
      </div>
      ${many ? `<div class="lg-strip" role="group" aria-label="${T('gallery_aria', 'Project image gallery')}">${images.map((s, i) => `<button type="button" class="lg-thumb${i ? '' : ' is-active'}" data-i="${i}" aria-label="${T('gal_show', 'Show photo {n}', {n: i + 1})}" aria-pressed="${i ? 'false' : 'true'}"><img src="${s}" alt="" loading="lazy" decoding="async"><span>${pad(i + 1)}</span></button>`).join('')}</div>` : ''}`;

    const stage = viewer.querySelector('.lg-stage');
    const img = viewer.querySelector('.lg-img');
    const amb = viewer.querySelector('.lg-ambient img');
    const countB = viewer.querySelector('.lg-count b');
    const thumbs = Array.from(viewer.querySelectorAll('.lg-thumb'));
    const bar = viewer.querySelector('.lg-bar i');

    const show = (i, animate) => {
      i = ((i % images.length) + images.length) % images.length;
      const dir = i >= index ? 1 : -1;
      index = i;
      const src = images[i];
      const swap = () => {
        img.src = src; amb.src = src;
        img.alt = altText(title, i + 1, images.length);
        countB.textContent = pad(i + 1);
        stage.setAttribute('aria-label', T('gal_open', 'Open photo {n} full screen', {n: i + 1}));
        thumbs.forEach((t, k) => { t.classList.toggle('is-active', k === i); t.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        const t = thumbs[i];
        if (t) t.parentElement.scrollTo({left: t.offsetLeft - t.parentElement.clientWidth / 2 + t.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth'});
        if (!reduce && animate) {
          img.animate([{opacity: 0, transform: `translateX(${22 * dir}px) scale(1.025)`, filter: 'blur(8px)'}, {opacity: 1, transform: 'none', filter: 'blur(0)'}], {duration: 800, easing: EASE});
          amb.animate([{opacity: 0}, {opacity: 1}], {duration: 900, easing: 'ease-out'});
        }
        preload(images[(i + 1) % images.length]);
      };
      swap();
    };
    show(0, false);

    viewer.addEventListener('click', e => {
      const t = e.target.closest('button');
      if (t && t.classList.contains('lg-thumb')) { show(Number(t.dataset.i), true); restart(); return; }
      if (t && t.classList.contains('lg-next')) { show(index + 1, true); restart(); return; }
      if (t && t.classList.contains('lg-prev')) { show(index - 1, true); restart(); return; }
      if (e.target.closest('.lg-stage')) openLightbox(images, index, title, img);
    });
    stage.addEventListener('keydown', e => {
      if (e.target !== stage) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(images, index, title, img); }
      else if (e.key === 'ArrowRight') { show(index + 1, true); restart(); }
      else if (e.key === 'ArrowLeft') { show(index - 1, true); restart(); }
    });

    /* gentle parallax: the photo drifts toward the cursor, like light catching it */
    if (!reduce && window.matchMedia('(hover:hover)').matches) {
      const frame = viewer.querySelector('.lg-frame');
      stage.addEventListener('pointermove', e => {
        const r = stage.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width - .5, py = (e.clientY - r.top) / r.height - .5;
        frame.style.transform = `translate3d(${px * -14}px,${py * -10}px,0) scale(1.012)`;
        stage.style.setProperty('--mx', `${(px + .5) * 100}%`);
        stage.style.setProperty('--my', `${(py + .5) * 100}%`);
      });
      stage.addEventListener('pointerleave', () => { frame.style.transform = ''; });
    }

    /* quiet autoplay while the viewer is on screen and untouched */
    let timer = 0, hover = false, visible = false;
    const DUR = 6500;
    function restart() {
      clearTimeout(timer);
      if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; }
      if (!many || reduce || hover || !visible || lb) return;
      if (bar) bar.style.animation = `lg-bar ${DUR}ms linear forwards`;
      timer = setTimeout(() => { show(index + 1, true); restart(); }, DUR);
    }
    stage.addEventListener('pointerenter', () => { hover = true; restart(); });
    stage.addEventListener('pointerleave', () => { hover = false; restart(); });
    viewer.addEventListener('focusin', () => { hover = true; restart(); });
    viewer.addEventListener('focusout', () => { hover = false; restart(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(es => { visible = es[0].isIntersecting; restart(); }, {threshold: .5}).observe(viewer);
    }
  }

  const scan = root => (root || document).querySelectorAll('.project-gallery-viewer:not([data-lux])').forEach(enhance);
  const boot = () => {
    scan();
    new MutationObserver(m => { if (m.some(r => r.addedNodes.length)) scan(); }).observe(document.body, {childList: true, subtree: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
